import React from 'react';
import { connect } from 'react-redux';
import { DtpButtonIcon } from 'dtp-react-components';
import PropTypes from 'prop-types';
import Masks from '../../../utils/masks';
import ModalAlteracaoDataEMotivoCessacao from '../ModalAlteracaoDataEMotivoCessacao';
import {
  Button,
  ControleDocumentos,
  DataGrid,
  Grid,
  Input,
} from '../../../components/index';
import store from '../../../reducers';
import ProtectedItem from '../../../components/ComponentesAutenticacao/ProtectedItem';
import CalculoCompensacao from './CalculoCompensacao';
import ResultadoAnalise from '../ResultadoAnalise';
import {
  sexo,
  tipoAposentadoriaRGPS,
  tipoAposentadoriaRPPS,
  parecerMedico,
  regrasDeCalculo,
} from '../../../utils/listsSelect';
import * as constantes from '../../../utils/constants';
import SelecaoDestinatario from './SelecaoDestinatario';
import Destinacao from '../Destinacao';
import DestinacaoExigencia from '../DestinacaoExigencia';
import CumprimentoExigencia from '../CumprimentoExigencia';
import SolicitanteDestinatario from '../SolicitanteDestinatario';
import UploadArquivos from '../UploadArquivos';
import User from '../../../domain/User';
import ModalCadeiaDeNit from '../ModalCadeiaDeNit';
import ModalAlteracaoDataCessacao from '../ModalAlteracaoDataCessacao';
import ProtocoloCertidao from '../ProtocoloCertidao';
import MultiplosPeriodos from '../MultiplosPeriodos';
import SegregacaoDeMassa from '../SegregacaoDeMassa';
import ModalAlteracaoSegregacaoMassa from '../ModalAlteracaoSegregacaoMassa';
import ModalAlteracaoMotivoCessacao from '../ModalAlteracaoMotivoCessacao';

const APOSENTADORIA_POR_INVALIDEZ = 3;
const MOTIVO_REVERSAO = 75;
const MOTIVO_CAPACIDADE_SEGURADO = 24;
const camposDesabilitadosAlteracaoRequerimento = [
  'cpf',
];

/* const camposHabilitadosParaAlteracaoNaAnalise = ['dataDesvinculacao',
  'dataIngresso', 'dataHomologacaoTribunalContas']; */
const camposHabilitadosParaAlteracaoNaAnalise = ['dataHomologacaoTribunalContas'];

const DadosRequerimentoAposentadoria = (props) => {
  // O campo "destinatario" é diferente se for um requerimento novo ou um já existente
  const isDestinatarioRPPS = () => {
    if (props.estadoFormulario.acao === 'realizar-analise'
        || props.estadoFormulario.acao === 'cumprir-exigencia'
        || props.estadoFormulario.acao === 'consulta') {
      return props.estadoFormulario.requerimento.destinatario
          && props.estadoFormulario.requerimento.destinatario.codigo !== '01000'
          && props.estadoFormulario.requerimento.destinatario.codigo !== null;
    } else if (props.estadoFormulario.acao === 'novo') {
      return props.estadoFormulario.requerimento.destinatario !== '01000'
          && props.estadoFormulario.requerimento.destinatario !== null;
    }

    return props.estadoFormulario.requerimento.destinatario && props.estadoFormulario.requerimento.destinatario.codigo !== '01000';
  };

  const isSolicitanteRPPS = () => {
    if (props.estadoFormulario.acao === 'realizar-analise'
        || props.estadoFormulario.acao === 'cumprir-exigencia'
        || props.estadoFormulario.acao === 'consulta'
        || props.estadoFormulario.acao === 'indeferidos'
        || props.estadoFormulario.acao === 'complementar-aposentadoria') {
      return props.estadoFormulario.requerimento.solicitante && props.estadoFormulario.requerimento.solicitante.codigo !== '01000';
    } else if (props.estadoFormulario.acao === 'novo') {
      return User.logged().isRPPS();
    }
    return false;
  };

  const isExibirCtcEspecifica = () => {
    let retorno = false;
    let destinatario;
    let solicitante;

    if (props.estadoFormulario.acao === 'novo') {
      destinatario = props.estadoFormulario.requerimento.destinatario === '01000';
    } else {
      destinatario = props.estadoFormulario.requerimento.destinatario
          && (props.estadoFormulario.requerimento.destinatario.codigo === '01000' || props.estadoFormulario.requerimento.destinatario === '01000');
    }

    if (props.estadoFormulario.acao === 'realizar-analise'
        || props.estadoFormulario.acao === 'cumprir-exigencia'
        || props.estadoFormulario.acao === 'consulta'
        || props.estadoFormulario.acao === 'indeferidos'
        || props.estadoFormulario.acao === 'complementar-aposentadoria') {
      solicitante = props.estadoFormulario.requerimento.solicitante && (props.estadoFormulario.requerimento.solicitante.codigo !== '01000'
        && props.estadoFormulario.requerimento.solicitante !== '01000') && props.estadoFormulario.requerimento.solicitante.codigo !== null;
    } else if (props.estadoFormulario.acao === 'novo') {
      solicitante = User.logged().isRPPS();
    }

    if (destinatario && solicitante) {
      retorno = true;
    } else if (props.estadoFormulario.requerimento.ctcEspecifica !== 0) {
      const changeObj = {
        value: 0,
      };
      props.handleChangeCtcEspecifica(changeObj);
    }
    return retorno;
  };

  const isDestinatarioPreenchido = () => props.estadoFormulario.requerimento.destinatario !== null;

  const getLabelParecerMedico = () => {
    if (props.estadoFormulario.requerimento.destinatario) {
      return props.estadoFormulario.requerimento.destinatario.codigo === '01000' ?
        'Enquadramento no artigo 151 da lei 8213/91' :
        'A aposentadoria por invalidez é em decorrência de acidente de serviço, moléstia profissional ou doença grave, contagiosa ou incurável, nos termos da Legislação do Ente?';
    }
    return '';
  };

  /**
   * Teste as condicoes para definir dentre os campos alternativos Matricula e Numero de Beneficio
   * qual deve ser exibido.
   */
  const controleCampoAlternativos = (campo) => {
    switch (campo) {
      case 'numeroBeneficio':
        if (!['novo', 'cumprir-exigencia'].includes(props.estadoFormulario.acao)) {
          // Se formulario estiver alterando requerimento, campo deve ser exibido quando preenchido
          if (props.estadoFormulario.requerimento.numeroBeneficio) {
            return Object.keys(constantes.rolesCadastradas);
          }
          return [];
        }
        // Quando for criacao de requerimento, apenas RGPS deve possuir campo Numero de Beneficio
        return ['requerer-compensacao-rgps', 'gerenciar-negocio-dcomp'];
      case 'dataIngresso':
        if (props.estadoFormulario.acao !== 'novo') {
        // Se formulario estiver alterando requerimento, campo deve ser exibido quando preenchido
          if (props.estadoFormulario.requerimento.dataIngresso) {
            return Object.keys(constantes.rolesCadastradas);
          }
          return [];
        }
        // Quando for criacao de requerimento, apenas RGPS deve possuir campo Data de Ingresso
        return ['requerer-compensacao-rgps', 'gerenciar-negocio-dcomp'];
      case 'dataHomologacaoTribunalContas':
        if (!['novo', 'cumprir-exigencia'].includes(props.estadoFormulario.acao)) {
          // Se formulario estiver diferente de em exigencia ou novo,
          // mostrar data de homologacao quando solicitante for RPPS
          if (props.estadoFormulario.requerimento.solicitante &&
            props.estadoFormulario.requerimento.solicitante.codigo !== '01000') {
            return Object.keys(constantes.rolesCadastradas);
          }
          return [];
        }
        // Quando for criacao ou exigencia de requerimento, apenas RPPS deve ver campo
        return ['requerer-compensacao-rpps'];
      case 'dataCreditoPagamento':
        if (!['novo', 'cumprir-exigencia'].includes(props.estadoFormulario.acao)) {
          // Se formulario estiver diferente de em exigencia ou novo,
          // mostrar data de homologacao quando solicitante for RGPS
          if (props.estadoFormulario.requerimento.solicitante &&
            props.estadoFormulario.requerimento.solicitante.codigo === '01000') {
            return Object.keys(constantes.rolesCadastradas);
          }
          return [];
        }
        // Quando for criacao ou exigencia de requerimento, apenas RGPS deve ver campo
        return ['requerer-compensacao-rgps', 'gerenciar-negocio-dcomp'];
      case 'idUOMantenedora':
        if (!['novo', 'cumprir-exigencia', 'realizar-analise'].includes(props.estadoFormulario.acao)) {
          // Se formulario estiver diferente de em exigencia ou novo,
          // mostrar idUOMantenedora quando solicitante for RGPS
          if ((props.estadoFormulario.requerimento.solicitante &&
            props.estadoFormulario.requerimento.solicitante.codigo === '01000')) {
            return Object.keys(constantes.rolesCadastradas);
          }
          return [];
        }
        // Quando for criacao ou exigencia de requerimento, apenas RGPS deve ver campo
        return ['requerer-compensacao-rgps', 'gerenciar-negocio-dcomp'];
      default:
        return [];
    }
  };

  /*
   * Verifica a existencia de um determinado tipo de documento carregado em requerimentos
   * neste caso estamos especifico estamos verificando o tipoDocumento = 2  (Homologação Tribunal)
   * se econtrar retorna verdadeiro.
   * @param {*} tipoEmDocumentosProbatorios
   * @returns
   */

  // const existeTipoDocumentoCarregadoNoRequerimento = (tipoEmDocumentosProbatorios) => {
  //   const existeTipoDocumento = props.estadoFormulario.requerimento.documentosProbatorios.some(documento => documento.tipoDocumento === tipoEmDocumentosProbatorios);
  //   return existeTipoDocumento;
  // };

  /**
   * Converter uma string em data
   * formato dd/mm/yyyy
   */
  // const convertStringToDate = (dateString) => {
  //   const [day, month, year] = dateString.split('/').map(part => parseInt(part, 10));
  //   // Mês é 0-indexado em JavaScript, então subtraímos 1 do mês
  //   const StringDateConvObjeto = new Date(year, month - 1, day);
  //   // Formatar a data para 'dd/mm/yyyy'
  //   const formattedDate = `${StringDateConvObjeto.getDate().toString().padStart(2, '0')}/${
  //     (StringDateConvObjeto.getMonth() + 1).toString().padStart(2, '0')}/${
  //     StringDateConvObjeto.getFullYear().toString()}`;
  //     // retorna data formatada como 'dd/mm/yyyy'
  //   return formattedDate;
  // };

  // const dateAberturaRequerimentoObject = convertStringToDate(DATESTRING);

  // const isDataHomologacaoTribunalContasValid = (tipoEmDocumentosProbatorios, dateAberturaRequerimentoParam) => {
  //   const isValid = ((props.estadoFormulario.dataHomologacaoTribunalContas === null || props.estadoFormulario.dataHomologacaoTribunalContas === undefined) &&
  //   (props.estadoFormulario.requerimento.dataAberturaRequerimento !== null || props.estadoFormulario.requerimento.dataAberturaRequerimento !== undefined));
  //   if (isValid) {
  //     if ((!existeTipoDocumentoCarregadoNoRequerimento(tipoEmDocumentosProbatorios) &&
  //     dateAberturaRequerimentoParam <= dateAberturaRequerimentoObject) ||
  //     (dateAberturaRequerimentoParam > dateAberturaRequerimentoObject)) {
  //       return isValid;
  //     }
  //   }
  //   return !isValid;
  // };

  const verificaSeCampoDesabilitado = (name) => {
    const { acao } = { ...props };
    const { isObtidoPelaRFB } = { ...props.estadoFormulario };
    // const tipoEmDocumentosProbatorios = 2;
    if (!['cumprir-exigencia', 'novo', 'realizar-analise', 'qualificar', 'indeferidos'].includes(acao)) {
      if (acao === 'complementar-aposentadoria') {
        if ((name === 'dataIngresso' || name === 'dataDesvinculacao') &&
        props.auth.checkPermission(['requerer-compensacao-rpps', 'analisar-compensacao-rpps'])) {
          return true;
        }
        if ((name === 'tempoContribuicaoRegimeOrigemDias') &&
        props.auth.checkPermission(['requerer-compensacao-rpps', 'analisar-compensacao-rpps'])) {
          if (props.estadoFormulario.requerimento.alteracaoTempoRO) {
            return false;
          }
          return true;
        }
        if ((name === 'dataHomologacaoTribunalContas' &&
        props.auth.checkPermission(['requerer-compensacao-rpps', 'analisar-compensacao-rpps']))) {
        // if (isDataHomologacaoTribunalContasValid(tipoEmDocumentosProbatorios, dateAberturaRequerimentoObject)) {
          return false;
        // }
        }
        if ((name === 'alteracaoManualTempoRo') &&
        props.auth.checkPermission(['requerer-compensacao-rpps', 'analisar-compensacao-rpps'])) {
          return false;
        }
        if ((name === 'ctcEspecifica') &&
        props.auth.checkPermission(['requerer-compensacao-rpps', 'analisar-compensacao-rpps'])) {
          return false;
        }
      }
      return true;
    }

    if (acao === 'qualificar') {
      if ((name === 'sexo' || name === 'nit') &&
          isObtidoPelaRFB === true &&
          props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp',
            'requerer-compensacao-rpps', 'analisar-compensacao-rpps'])) {
        return false;
      }
      return name !== 'cpf';
    }

    if (acao === 'indeferidos') {
      const { isRmiZerada } = { ...props.estadoFormulario };
      if ((name === 'sexo' || name === 'nit') &&
          isObtidoPelaRFB === true &&
          props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp',
            'requerer-compensacao-rpps', 'analisar-compensacao-rpps'])) {
        return false;
      }

      if ((['matricula'].includes(name) &&
      props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps']))
          || ((isRmiZerada && name === 'rendaMensalInicial') &&
          props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps'])
          )) {
        return false;
      }

      if (['matricula', 'tipoAposentadoria', 'dataInicioBeneficio', 'dataInicioPagamentoBeneficio',
        'dataCessacaoBeneficio', 'tempoContribuicaoTotalDias',
        'rendaMensalInicial', 'dataHomologacaoTribunalContas'].includes(name) &&
        props.auth.checkPermission(['analisar-compensacao-rpps', 'requerer-compensacao-rpps'])) {
        return false;
      }

      if (name === 'tempoContribuicaoTotalDias' &&
      props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp'])) {
        return false;
      }

      if (name === 'tempoContribuicaoRegimeOrigemDias' &&
      props.auth.checkPermission(['analisar-compensacao-rpps', 'requerer-compensacao-rpps',
        'requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp'])) {
        if (props.estadoFormulario.requerimento.alteracaoTempoRO) {
          return false;
        }
        return true;
      }

      if ((name === 'alteracaoManualTempoRo') &&
      props.auth.checkPermission(['analisar-compensacao-rpps', 'requerer-compensacao-rpps',
        'requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp'])) {
        return false;
      }

      if ((name === 'ctcEspecifica') &&
      props.auth.checkPermission(['analisar-compensacao-rpps', 'requerer-compensacao-rpps',
        'requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp'])) {
        return false;
      }

      if ((name === 'dataIngresso' || name === 'dataDesvinculacao') &&
      props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'requerer-compensacao-rpps', 'analisar-compensacao-rpps', 'gerenciar-negocio-dcomp'])) {
        return true;
      }

      if (name === 'motivoCessacaoManual') {
        const r = props.estadoFormulario.requerimento;
        const cnpjUsuarioLogado = User.logged().cnpjDoPapel();
        const cnpjSolicitante = r.solicitante ? r.solicitante.cnpj : null;
        const isRGPS = User.logged().isRGPS();
        if ((cnpjUsuarioLogado === cnpjSolicitante) ||
            (r.solicitante && r.solicitante.codigo === '01000' && isRGPS)) {
          return false;
        }
        return true;
      }

      return true;
    }

    if (acao === 'realizar-analise') {
      if (props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp'])) {
        if (props.estadoFormulario.requerimento.dataMigracao !== null) {
          return !camposHabilitadosParaAlteracaoNaAnalise.includes(name);
        }

        const { habilitarCamposParaAlteracaoNaAnalise } = { ...props.estadoFormulario };
        if (camposHabilitadosParaAlteracaoNaAnalise.includes(name) && habilitarCamposParaAlteracaoNaAnalise) {
          return false;
        }
      }
      return true;
    }

    if (acao === 'cumprir-exigencia') {
      if ((name === 'sexo' || name === 'nit') &&
        isObtidoPelaRFB === true &&
        props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp',
          'requerer-compensacao-rpps', 'analisar-compensacao-rpps'])) {
        return false;
      }

      if (name === 'tempoContribuicaoTotalDias' &&
      props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp'])) {
        return false;
      }

      if ((name === 'rendaMensalInicial') &&
      props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp',
        'requerer-compensacao-rpps', 'analisar-compensacao-rpps'])) {
        const { isRmiZerada, rendaMensalInicialRequest } = { ...props.estadoFormulario };
        if (isRmiZerada === true ||
          (rendaMensalInicialRequest !== null && rendaMensalInicialRequest === 0)) {
          return false;
        }
      }

      if ((name === 'dataIngresso' || name === 'dataDesvinculacao') &&
      props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'requerer-compensacao-rpps', 'analisar-compensacao-rpps', 'gerenciar-negocio-dcomp'])) {
        return true;
      }

      if (name === 'tempoContribuicaoRegimeOrigemDias' &&
      props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'requerer-compensacao-rpps', 'analisar-compensacao-rpps', 'gerenciar-negocio-dcomp'])) {
        if (props.estadoFormulario.requerimento.alteracaoTempoRO) {
          return false;
        }
        return true;
      }

      if (name === 'motivoCessacaoManual') {
        const req = props.estadoFormulario.requerimento;
        const isRGPS = User.logged().isRGPS();
        if (isRGPS) {
          if (req && (req.tipoAposentadoria === null)) {
            return true;
          }
        }
        return false;
      }

      return camposDesabilitadosAlteracaoRequerimento.includes(name) ||
        props.camposCnis.includes(name) ||
        (props.camposCentralService.includes(name) && props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp']));
    }

    if (acao === 'novo') {
      if ((name === 'sexo' || name === 'nit') &&
        isObtidoPelaRFB === true &&
        props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp',
          'requerer-compensacao-rpps', 'analisar-compensacao-rpps'])) {
        return false;
      }
      if (name === 'tempoContribuicaoTotalDias' &&
      props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp'])) {
        return false;
      }
      if ((name === 'rendaMensalInicial') &&
      props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp'])) {
        const { isRmiZerada, rendaMensalInicialRequest } = { ...props.estadoFormulario };
        if (isRmiZerada === true ||
          (rendaMensalInicialRequest !== null && rendaMensalInicialRequest === 0)) {
          return false;
        }
      }

      if ((name === 'dataIngresso' || name === 'dataDesvinculacao') &&
      props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'requerer-compensacao-rpps', 'analisar-compensacao-rpps', 'gerenciar-negocio-dcomp'])) {
        return true;
      }

      if ((name === 'tempoContribuicaoRegimeOrigemDias') &&
      props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'requerer-compensacao-rpps', 'analisar-compensacao-rpps', 'gerenciar-negocio-dcomp'])) {
        if (props.estadoFormulario.requerimento.alteracaoTempoRO) {
          return false;
        }
        return true;
      }

      if (name === 'motivoCessacaoManual') {
        const req = props.estadoFormulario.requerimento;
        const isRGPS = User.logged().isRGPS();
        if (isRGPS) {
          // habilita mesmo se a data de cessacao nao estiver preenchida pois ela pode vir vazia do central service
          if (req && (req.tipoAposentadoria === null)) {
            return true;
          }
        }
        return false;
      }

      return props.camposCnis.includes(name) ||
        (props.camposCentralService.includes(name) &&
        props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp']));
    }

    return false;
  };

  const handleDocuments = () => {
    let documentos = [];
    if (props.estadoFormulario.requerimento.documentosProbatorios &&
      props.estadoFormulario.requerimento.documentosProbatorios.length > 0) {
      documentos = props.estadoFormulario.requerimento.documentosProbatorios.map(docs => ({
        key: docs.codigo,
        documentType: docs.tipoDocumento,
      }));
    }
    return documentos;
  };

  const acao = { MARCAR: 'marcar', DESMARCAR: 'desmarcar' };
  const checkedTempoRO = (props.estadoFormulario.requerimento.alteracaoTempoRO === 1);
  const checkedCtcEspecifica = (props.estadoFormulario.requerimento.ctcEspecifica === 1);
  const clicouTempoRO = checkedTempoRO ? acao.DESMARCAR : acao.MARCAR;
  const clicouCtcEspecifica = checkedCtcEspecifica ? acao.DESMARCAR : acao.MARCAR;


  const r = props.estadoFormulario.requerimento;
  const temMotivo = r && r.motivoCessacaoManual != null;
  const temData = r && r.dataCessacaoBeneficio != null;
  const estadosAnalise = [4, 5, 10]; // Aguardando Análise, Médico, Suspensa
  const estadosFinalizados = [8, 11, 12]; // Deferido, Em Compensação, Compensado
  const estadosPermitidos = [4, 5, 8, 10, 11, 12];
  const ambosVazios = !temData && !temMotivo;

  const exibirLapisDataCessacao = (
    r &&
    r.solicitante &&
    props.estadoFormulario.acao === 'consulta' &&

    (
      // pode só incluir data (não alterar)
      (
        estadosAnalise.includes(r.estado) &&
        !temData
      )
    ) &&

    (
      r.solicitante.cnpj === User.logged().cnpjDoPapel() ||
      (r.solicitante.codigo === '01000' && User.logged().isRGPS())
    )
  );

  // se ele ja tiver mexido em motivo de cessação e estiver nos estados previstos (em compensacao, compensado, deferido), nao deixa editar
  // O motivo de cessação automática por óbito (CNIS) não poderá ser alterado pelo usuário para os estados permitidos. 12 é o codigo de cessacao pelo CNIS
  const hasHistoricoBloqueante = () =>
    ([8, 11, 12].includes(r.estado) &&
      (
        !r.dataCessacaoBeneficio ||
      (r.historicoAuditorias || []).some(a => a.codigo === 36)
      )) ||
    (estadosPermitidos.includes(r.estado) && (r.historicoAuditorias || []).some(a => a.codigo === 17)
    && props.estadoFormulario && props.estadoFormulario.requerimento && props.estadoFormulario.requerimento.motivoCessacaoManual === 12);

  const exibirLapisMotivo = (
    r &&
    r.solicitante &&
    props.estadoFormulario.acao === 'consulta' &&

    (
      //  ambos vazios, exibe o lapis para permitir edição dos dois ao mesmo tempo
      (estadosPermitidos.includes(r.estado) && ambosVazios && !hasHistoricoBloqueante())

      ||
      //  REGRA 2: só incluir motivo (não pode alterar)
      (
        estadosAnalise.includes(r.estado) &&
        temData &&
        !temMotivo
      )

      ||

      // REGRA 4: incluir/alterar uma única vez (controlado por histórico)
      (
        estadosFinalizados.includes(r.estado) &&
        temData &&
        !hasHistoricoBloqueante()
      )
    ) &&

    (
      r.solicitante.cnpj === User.logged().cnpjDoPapel() ||
      (r.solicitante.codigo === '01000' && User.logged().isRGPS())
    )
  );

  const toggleCheckbox = (acaoToggle, nome) => {
    const changeObj = {};
    let historyCheckTempoRO;
    if (acaoToggle === acao.DESMARCAR) {
      changeObj.value = 0;
      historyCheckTempoRO = 1;
    } else {
      changeObj.value = 1;
      historyCheckTempoRO = 0;
    }
    if (nome === 'alteracaoManualTempoRo') {
      if (changeObj.value === 0) {
        if (props.estadoFormulario.acao === 'novo') {
          props.atualizarTempoRO(props.estadoFormulario.historyTempoRO);
        } else {
          props.handleModalTempoRO();
        }
      }
      props.handleChangeTempoROManual(changeObj, historyCheckTempoRO);
    } else {
      props.handleChangeCtcEspecifica(changeObj);
    }
  };

  const verificaAcaoExibicaoBotaoPesquisarCTC = () => {
    // return !['consulta', 'realizar-analise','qualificar'].includes(props.estadoFormulario.acao);
    switch (props.estadoFormulario.acao) {
      case 'realizar-analise':
        return false;
      case 'consulta':
        return false;
      case 'emitir-parecer-medico':
        return false;
      default:
        break;
    }

    return (
      (props.estadoFormulario.requerimento.destinatario && props.estadoFormulario.requerimento.destinatario === '01000') ||
      (props.estadoFormulario.requerimento.destinatario && props.estadoFormulario.requerimento.destinatario.codigo === '01000')
    );
  };

  const verificarTamanhoInput = () => {
    let retorno = '4 4 4 4';
    if (verificaAcaoExibicaoBotaoPesquisarCTC()) {
      retorno = '3 3 3 3';
    }
    return retorno;
  };

  let pesquisar;
  let exibirElosNIT;
  let pesquisarNB;
  let checkExigirQualificacaoCPF;

  const botaoAlterarDataCessacao = (
    <DtpButtonIcon
      icon="ico-pencil"
      className="icone"
      accessibilityName="Alterar data de cessação"
      onClick={() => {
        if (!temData && !temMotivo) {
          props.handleModalAlteraDataEMotivoCessacao();
        } else {
          props.handleModalAlteraDataCessacao('dataCessacao');
        }
      }}
      hint={props.estadoFormulario.requerimento.dataCessacaoBeneficio != null ? 'Alterar data de cessação' : 'Incluir data de cessação'}
    />
  );

  const botaoAlterarMotivoCessacao = (
    <DtpButtonIcon
      icon="ico-pencil"
      className="icone"
      accessibilityName="Alterar motivo de cessação"
      onClick={() => {
        if (!temData && !temMotivo) {
          props.handleModalAlteraDataEMotivoCessacao();
        } else {
          props.handleModalAlteraMotivoCessacao('motivoCessacao');
        }
      }}
      hint={props.estadoFormulario.requerimento.motivoCessacaoManual != null
        ? 'Alterar motivo de cessação'
        : 'Incluir motivo de cessação'}
    />
  );

  if (['novo', 'cumprir-exigencia', 'qualificar', 'indeferidos'].includes(props.estadoFormulario.acao)) {
    pesquisar = (
      <Button
        title="Pesquisar"
        onClick={() => props.handleSearchButton()}
        hint="Pesquisar dados pessoais"
      />
    );
    pesquisarNB = (
      <Button
        title="Pesquisar benefício"
        onClick={() => props.handleSearchNBButton()}
        hint="Pesquisar benefício"
      />
    );
  }
  if (['novo', 'realizar-analise', 'consulta', 'indeferidos', 'cumprir-exigencia'].includes(props.estadoFormulario.acao)) {
    exibirElosNIT = (
      <div>
        <DtpButtonIcon
          icon="ico-link"
          accessibilityName="Exibir NIT's elados"
          onClick={() => props.handlePesquisaBotaoEloNit()}
          hint="Exibir NIT's elados"
        />
      </div>
    );
  }
  if (props.estadoFormulario.acao === 'indeferidos') {
    checkExigirQualificacaoCPF = (
      <Input
        id="checkExigirQualificacaoCPF"
        label="Necessária alteração do CPF via qualificação"
        name="checkExigirQualificacaoCPF"
        onChange={e => props.handleChangeExigirQualificacao(e)}
        check
        value={props.estadoFormulario.checkExigirQualificacao}
      />
    );
  }

  let resultadoAnalise;
  if (props.estadoFormulario.acao === 'realizar-analise') {
    resultadoAnalise = (
      <ProtectedItem allowedPermissions={['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'gerenciar-negocio-dcomp']}>
        <ResultadoAnalise
          alteraEstado={props.alteraEstadoRequerimento}
          handleChange={props.handleChange}
          requerimento={props.estadoFormulario.requerimento}
          userData={props.auth.userData}
          vinculosConcomitantesConfirmado={props.vinculosConcomitantesConfirmado}
          possuiVinculosConcomitantes={props.possuiVinculosConcomitantes}
          clickVinculosTab={props.clickVinculosTab}
          tipoRequerimento={props.estadoFormulario.tipoRequerimento}
          inIndefericaoAnalise={props.estadoFormulario.inIndefericaoAnalise}
          atualizarDocumentosProbatorios={props.atualizarDocumentosProbatorios}
          motivosIndeferimentoControle={props.estadoFormulario.motivosIndeferimentoControle}
          validacaoDeVinculosConcomitantes={props.validacaoDeVinculosConcomitantes}
          atualizarVinculosConcomitantesConfirmado={props.atualizarVinculosConcomitantesConfirmado}
          handleChangeFile={props.handleChangeFile}
          handleChangeTipoDocumento={props.handleChangeTipoDocumento}
          tipoDocumento={props.estadoFormulario.tipoDocumento}
        />
      </ProtectedItem>
    );
  }

  if (props.estadoFormulario.acao === 'emitir-parecer-medico') {
    resultadoAnalise = (
      <ProtectedItem allowedPermissions={['fornecer-parecer-medico-rpps']}>
        <DataGrid title="Análise" icon="ico-process-check" >
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                label="Invalidez acidentária"
                itemList={parecerMedico}
                placeholder="Selecione a opção"
                value={props.estadoFormulario.requerimento.invalidezAcidentaria}
                onChange={e => props.handleChange(e, 'invalidezAcidentaria')}
              />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="12 12 12 12">
              <Input
                label={getLabelParecerMedico()}
                itemList={parecerMedico}
                placeholder="Selecione a opção"
                value={props.estadoFormulario.requerimento.enquadraArtigo151Lei8213}
                onChange={e => props.handleChange(e, 'enquadraArtigo151Lei8213')}
              />
            </Grid>
          </div>
        </DataGrid>
      </ProtectedItem>
    );
  }

  let cumprimentoExigencia;
  if (this.props && this.props.estadoFormulario.requerimento.estadoAtual === 2) {
    cumprimentoExigencia = (
      <CumprimentoExigencia
        handleChange={this.props.handleChange}
        requerimento={this.props.estadoFormulario.requerimento}
      />
    );
  }

  let documentosProbatorios;
  if (props.tiposDocumentos.length > 0) {
    documentosProbatorios = (
      <ControleDocumentos
        tiposDocumentos={props.tiposDocumentos}
        documents={handleDocuments()}
        protocolo={props.match.params.protocolo}
        auth={props.auth}
        acao={props.acao}
        requerimento={props.estadoFormulario.requerimento}
        atualizarDocumentosProbatorios={props.atualizarDocumentosProbatorios}
        tipoRequerimento={props.estadoFormulario.tipoRequerimento}
      />
    );
  }

  let calculoCompensacao;
  if (props.estadoFormulario.acao === 'consulta') {
    calculoCompensacao = (
      <CalculoCompensacao
        handleChange={props.handleChange}
        requerimento={props.estadoFormulario.requerimento}
      />
    );
  }

  const filterMotivos = (lista, requerimento, tipo) => {
    let motivosCessacaoFiltrado = [];
    const codigoTipo = tipo === 'aposentadoria' ? 1 : 2;
    const inss = '01000';
    let destinatarioOuSolicitanteRGPS = false;
    let regimes = [2, 3];
    const isRGPS = User.logged().isRGPS();

    if (requerimento.solicitante && requerimento.destinatario) {
      destinatarioOuSolicitanteRGPS = [requerimento.solicitante.codigo, requerimento.destinatario.codigo].includes(inss);
      if (requerimento.solicitante.codigo === inss) {
        regimes = [1, 3];
      }
    } else if (!requerimento.solicitante) {
      if (props.estadoFormulario.acao === 'novo' && isRGPS) {
        destinatarioOuSolicitanteRGPS = true;
        regimes = [1, 3];
      }
    }

    const acordos = (destinatarioOuSolicitanteRGPS) ? [1, 3] : [2, 3];
    motivosCessacaoFiltrado = lista.filter(motivo => (
      motivo.abrangenciaAplicavel === codigoTipo &&
      regimes.includes(motivo.regimeAplicavel) &&
      acordos.includes(motivo.acordoAplicavel)
    ));
    motivosCessacaoFiltrado = motivosCessacaoFiltrado.filter(motivo => motivo.value !== MOTIVO_CAPACIDADE_SEGURADO);
    if (isRGPS && requerimento.tipoAposentadoria !== APOSENTADORIA_POR_INVALIDEZ) {
      motivosCessacaoFiltrado = motivosCessacaoFiltrado.filter(motivo => motivo.value !== MOTIVO_REVERSAO);
    }
    const motivoAtual = requerimento.motivoCessacaoManual;

    const motivoValido = motivosCessacaoFiltrado.some(m => m.value === motivoAtual);

    if (motivoAtual != null && !motivoValido) {
    /* eslint-disable no-param-reassign */
      requerimento.motivoCessacaoManual = null;
    }
    return motivosCessacaoFiltrado;
  };

  const isMotivoCessacaoManualPreenchido = () => (
    (
      props.estadoFormulario.requerimento.motivoCessacaoManual !== null &&
      props.estadoFormulario.requerimento.motivoCessacaoManual !== '' &&
      props.estadoFormulario.requerimento.motivoCessacaoManual !== undefined
    )
  );
  const motivo = props.estadoFormulario.requerimento.motivoCessacaoManual;

  const data = props.estadoFormulario.requerimento.dataCessacaoBeneficio;

  const temData1 =
    data !== null &&
    data !== undefined &&
    data !== '';

  const temMotivo1 = motivo !== null && motivo !== undefined && motivo !== '';
  // IB499614
  const exibirComboBox = (nomeCombobox) => {
    let retorno = false;
    const listaAcoes = ['realizar-analise', 'novo', 'cumprir-exigencia', 'indeferidos', 'consulta'];

    switch (nomeCombobox) {
      case 'motivoCessacaoManual':
        //  para casos de novo requerimento, reabertura e alteracao
        if (listaAcoes.includes(props.estadoFormulario.acao)) {
          retorno = true;
        }
        break;

      default:
        break;
    }

    return retorno;
  };


  return (
    <React.Fragment>
      { (props.acao !== 'indeferidos' && props.acao !== 'cumprir-exigencia' && props.acao !== 'novo') &&
        <SolicitanteDestinatario requerimento={props.estadoFormulario.requerimento} />
      }

      { props.estadoFormulario.requerimento.solicitanteOrigem &&
        <DataGrid title="Detalhes do Solicitante" icon="ico-user" >
          <div className="row">
            <Grid cols="6 6 6 6">
              <Input
                disabled
                label="Solicitante de Origem"
                value={props.estadoFormulario.requerimento.solicitanteOrigem.nome}
                required
              />
            </Grid>
            <Grid cols="6 6 6 6">
              <Input
                disabled
                label="Código do Solicitante"
                value={props.estadoFormulario.requerimento.solicitanteOrigem.codigo}
                required
              />
            </Grid>
          </div>
        </DataGrid>
      }

      <DataGrid title="Dados Pessoais" icon="ico-user" >
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              cpf
              disabled={verificaSeCampoDesabilitado('cpf')}
              integer
              error={!props.estadoFormulario.validadeCampos.cpf}
              touched={props.estadoFormulario.touched || props.estadoFormulario.cpfTouched}
              label="CPF"
              mask={Masks.cpf}
              value={props.estadoFormulario.requerimento.cpf}
              onChange={e => props.handleChange(e, 'cpf')}
              showMask
              required
            />
          </Grid>
          <Grid cols="2 2 2 2">
            { pesquisar }
          </Grid>
          <Grid cols="6 6 6 6">
            <span
              data-tooltip="Ao selecionar esta opção, o requerimento será enviado para exigência / prazo para alterar o CPF."
              data-tooltip-position="bottom"
            >
              { checkExigirQualificacaoCPF }
            </span>
          </Grid>
          <Grid cols="12 12 12 12">
            <Input
              disabled={verificaSeCampoDesabilitado('nome')}
              error={!props.estadoFormulario.validadeCampos.nome}
              label="Nome"
              maxLength="100"
              onChange={e => props.handleChange(e, 'nome')}
              value={props.estadoFormulario.requerimento.nome}
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <span style={{ display: 'flex' }}>
              <Input
                disabled={verificaSeCampoDesabilitado('nit')}
                error={!props.estadoFormulario.validadeCampos.nit}
                integer
                label="NIT"
                mask={Masks.nit}
                nit
                onChange={e => props.handleChange(e, 'nit')}
                showMask
                touched={props.estadoFormulario.touched}
                value={props.estadoFormulario.requerimento.nit}
                required={props.estadoFormulario.isObtidoPelaRFB}
              />
              {['novo', 'realizar-analise', 'consulta', 'indeferidos', 'cumprir-exigencia'].includes(props.estadoFormulario.acao) &&
                props.estadoFormulario.requerimento.nit !== null &&
                (props.estadoFormulario.requerimento.elos && props.estadoFormulario.requerimento.elos.length !== 0) ? exibirElosNIT : ' '
              }
            </span>
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              disabled={verificaSeCampoDesabilitado('dataNascimento')}
              error={!props.estadoFormulario.validadeCampos.dataNascimento}
              touched={props.estadoFormulario.touched}
              mask={Masks.date}
              label="Data de Nascimento"
              value={props.estadoFormulario.requerimento.dataNascimento}
              onChange={e => props.handleChange(e, 'dataNascimento')}
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              disabled={verificaSeCampoDesabilitado('sexo')}
              error={!props.estadoFormulario.validadeCampos.sexo}
              number
              itemList={sexo}
              label="Sexo"
              onChange={e => props.handleChange(e, 'sexo')}
              placeholder="Selecione o sexo"
              touched={props.estadoFormulario.touched}
              value={props.estadoFormulario.requerimento.sexo}
              custom
              required={props.estadoFormulario.isObtidoPelaRFB}
            />
          </Grid>
          <Grid cols="12 12 12 12">
            <Input
              disabled={verificaSeCampoDesabilitado('nomeMae')}
              error={!props.estadoFormulario.validadeCampos.nomeMae}
              label="Nome da Mãe"
              maxLength="100"
              onChange={e => props.handleChange(e, 'nomeMae')}
              value={props.estadoFormulario.requerimento.nomeMae}
            />
          </Grid>
          <Grid cols="4 4 4 4">
            {isSolicitanteRPPS() &&
            <Input
              disabled={verificaSeCampoDesabilitado('matricula')}
                // error={props.estadoFormulario.validadeCampos.matricula}
              error={'matricula' in props.estadoFormulario.validadeCampos ? !props.estadoFormulario.validadeCampos.matricula : false}
              label="Matrícula Regime Instituidor"
              maxLength="11"
              onChange={e => props.handleChange(e, 'matricula')}
              touched={props.estadoFormulario.touched}
              value={props.estadoFormulario.requerimento.matricula}
              integer
              required
            />
            }
          </Grid>
        </div>
      </DataGrid>

      { props.entesControlados.length > 0 && props.enteDoUsuario &&
      <DataGrid title="Detalhes do Solicitante" icon="ico-user" >
        <div className="row">
          <Grid cols="8 8 8 8">
            <Input
              label="Solicitante de Origem"
              touched={props.estadoFormulario.touched}
              placeholder="Selecione o solicitante"
              itemList={[{
                codigo: props.enteDoUsuario.codigo,
                nome: props.enteDoUsuario.nome,
                cnpj: User.logged().cnpjDoPapel(),
              }]
                  .concat(props.entesControlados)
                  .map(e => ({ value: e.codigo, label: `${e.nome} (CNPJ: ${e.cnpj})` }))}
              required
              custom
              value={props.solicitanteRequerimento}
              onChange={(e) => {
                if (props.enteDoUsuario.codigo === e.value) {
                  props.handleChange({ isValid: true, value: null }, 'solicitanteOrigem');
                } else {
                  props.handleChange(e, 'solicitanteOrigem');
                }
                store.dispatch({ type: 'ALTERA_SOLICITANTE_REQUERIMENTO', payload: e.value });
              }}
            />
          </Grid>
        </div>
      </DataGrid> }

      { (props.acao === 'indeferidos' &&
        props.estadoFormulario.requerimento.solicitante) &&
        <Destinacao
          requerimento={props.estadoFormulario.requerimento}
          tipoRequerimento={props.estadoFormulario.tipoRequerimento}
          handleChange={props.handleChange}
          calcularTempoRO={props.calcularTempoRO}
        />
      }

      { (props.acao === 'cumprir-exigencia' &&
        props.estadoFormulario.requerimento.solicitante) &&
        <DestinacaoExigencia
          requerimento={props.estadoFormulario.requerimento}
          handleChange={props.handleChange}
          calcularTempoRO={props.calcularTempoRO}
        />
      }

      { (props.acao === 'novo' || props.acao === 'salvarERejeitar') &&
        <SelecaoDestinatario
          acao={props.estadoFormulario.acao}
          destinatario={props.estadoFormulario.requerimento.destinatario ?
                props.estadoFormulario.requerimento.destinatario : null}
          handleChange={props.handleChange}
          touched={props.estadoFormulario.touched}
          apagaRegraDeCalculo={props.apagaRegraDeCalculo}
          calcularTempoRO={props.calcularTempoRO}
          isRgpsSelecionando={props.auth.checkPermission(['requerer-compensacao-rgps', 'gerenciar-negocio-dcomp'])}
        />
      }

      <DataGrid title="Dados de Benefício" icon="ico-money" >
        <ProtectedItem allowedPermissions={controleCampoAlternativos('numeroBeneficio')}>
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                disabled={verificaSeCampoDesabilitado('numeroBeneficio')}
                error={'numeroBeneficio' in props.estadoFormulario.validadeCampos ? !props.estadoFormulario.validadeCampos.numeroBeneficio : false}
                touched={props.estadoFormulario.touched}
                label="Número de benefício"
                maxLength="11"
                integer
                value={props.estadoFormulario.requerimento.numeroBeneficio}
                onChange={e => props.handleChange(e, 'numeroBeneficio')}
                required
              />
            </Grid>
            <Grid cols="4 4 4 4">
              {pesquisarNB}
            </Grid>
          </div>
        </ProtectedItem>
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              disabled={verificaSeCampoDesabilitado('tipoAposentadoria') || !isDestinatarioPreenchido()}
              label="Tipo de Aposentadoria"
              number
              error={!props.estadoFormulario.validadeCampos.tipoAposentadoria}
              touched={props.estadoFormulario.touched}
              placeholder="Selecione o tipo de Aposentadoria"
              onChange={e => props.handleChange(e, 'tipoAposentadoria')}
              value={props.estadoFormulario.requerimento.tipoAposentadoria}
              itemList={isDestinatarioRPPS() ? tipoAposentadoriaRPPS : tipoAposentadoriaRGPS}
              required
              custom
            />
          </Grid>
          <Grid cols={exibirLapisMotivo ? '7 7 7 7' : '8 8 8 8'}>
            {(exibirComboBox('motivoCessacaoManual')) &&
              <Input
                disabled={verificaSeCampoDesabilitado('motivoCessacaoManual')}
                label="Motivo Cessação"
                number
                error={'motivoCessacaoManual' in props.estadoFormulario.validadeCampos ? !props.estadoFormulario.validadeCampos.motivoCessacaoManual : false}
                touched={props.estadoFormulario.touched}
                placeholder="Selecione o Motivo da Cessação"
                onChange={e => props.handleChange(e, 'motivoCessacaoManual')}
                value={props.estadoFormulario.requerimento.motivoCessacaoManual}
                itemList={filterMotivos(
                    props.motivosCessacao,
                    props.estadoFormulario.requerimento,
                    'aposentadoria',
                  )}
                required={temData1}
                custom
              />
            }
          </Grid>
          {(exibirLapisMotivo && props.acao === 'consulta') && (
            <Grid cols="1 1 1 1">
              <div className={isMotivoCessacaoManualPreenchido ?
                'botao-lapis-motivo-cessacao-verde' :
                'botao-lapis-motivo-cessacao-cinza'}
              >
                { botaoAlterarMotivoCessacao }
              </div>
            </Grid>
          )}
        </div>
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              disabled={verificaSeCampoDesabilitado('dataInicioBeneficio')}
              error={'dataInicioBeneficio' in props.estadoFormulario.validadeCampos ? !props.estadoFormulario.validadeCampos.dataInicioBeneficio : false}
              label="Data de Início de Benefício"
              mask={Masks.date}
              value={props.estadoFormulario.requerimento.dataInicioBeneficio}
              onChange={e => props.handleChange(e, 'dataInicioBeneficio')}
              touched={props.estadoFormulario.touched}
              required
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              disabled={verificaSeCampoDesabilitado('dataInicioPagamentoBeneficio')}
              error={'dataInicioPagamentoBeneficio' in props.estadoFormulario.validadeCampos ? !props.estadoFormulario.validadeCampos.dataInicioPagamentoBeneficio : false}
              label="Data de Início de Pagamento"
              mask={Masks.date}
              value={props.estadoFormulario.requerimento.dataInicioPagamentoBeneficio}
              onChange={e => props.handleChange(e, 'dataInicioPagamentoBeneficio')}
              touched={props.estadoFormulario.touched}
            />
          </Grid>
          <Grid cols={exibirLapisDataCessacao ? '3 3 3 3' : '4 4 4 4'}>
            <Input
              disabled={verificaSeCampoDesabilitado('dataCessacaoBeneficio')}
              error={'dataCessacaoBeneficio' in props.estadoFormulario.validadeCampos ? !props.estadoFormulario.validadeCampos.dataCessacaoBeneficio : false}
              label="Data de Cessação"
              mask={Masks.date}
              value={props.estadoFormulario.requerimento.dataCessacaoBeneficio}
              onChange={e => props.handleChange(e, 'dataCessacaoBeneficio')}
              required={temMotivo1}
              touched={props.estadoFormulario.touched}
            />
          </Grid>
          {exibirLapisDataCessacao ?
            <Grid cols="1 1 1 1"><div className="botao-lapis">{ botaoAlterarDataCessacao }</div></Grid>
          : '' }
        </div>
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              disabled={verificaSeCampoDesabilitado('tempoContribuicaoTotalDias')}
              error={!props.estadoFormulario.validadeCampos.tempoContribuicaoTotalDias}
              guide={false}
              integer
              label="Tempo de Contribuição Total (dias)"
              mask={Masks.integer}
              maxLength="6"
              number
              onChange={e => props.handleChange(e, 'tempoContribuicaoTotalDias')}
              required
              touched={props.estadoFormulario.touched}
              value={props.estadoFormulario.requerimento.tempoContribuicaoTotalDias}
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              disabled={verificaSeCampoDesabilitado('tempoContribuicaoRegimeOrigemDias')}
              number
              integer
              error={props.estadoFormulario.exigenciasInvalidas.tempoContribuicaoRegimeOrigemDias}
              touched={props.estadoFormulario.touched}
              label="Tempo de Contribuição no Reg. de Origem (dias)"
              mask={Masks.integer}
              maxLength="6"
              guide={false}
              value={props.estadoFormulario.requerimento.tempoContribuicaoRegimeOrigemDias}
              onChange={e => props.handleChange(e, 'tempoContribuicaoRegimeOrigemDias')}
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              currency
              showMask={false}
              disabled={verificaSeCampoDesabilitado('rendaMensalInicial')}
              label="Renda Mensal Inicial"
              error={!props.estadoFormulario.validadeCampos.rendaMensalInicial}
              touched={props.estadoFormulario.touched}
              maxLength="16"
              value={props.estadoFormulario.requerimento.rendaMensalInicial}
              required
              onChange={e => props.handleChange(e, 'rendaMensalInicial')}
              onKeyUp={e => props.handleKeyUp(e, 'rendaMensalInicial')}
            />
          </Grid>
        </div>
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              disabled={verificaSeCampoDesabilitado('dataIngresso')}
              // required={!props.estadoFormulario.habilitarCamposParaAlteracaoNaAnalise}
              error={props.estadoFormulario.exigenciasInvalidas.dataIngresso}
              mask={Masks.date}
              label="Data de ingresso no regime de origem"
              onChange={e => props.handleChange(e, 'dataIngresso')}
              value={props.estadoFormulario.requerimento.dataIngresso}
              touched={props.estadoFormulario.touched}
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              disabled={verificaSeCampoDesabilitado('dataDesvinculacao')}
              // required={!props.estadoFormulario.habilitarCamposParaAlteracaoNaAnalise}
              error={props.estadoFormulario.exigenciasInvalidas.dataDesvinculacao}
              mask={Masks.date}
              label="Data de desvinculação no regime de origem"
              onChange={e => props.handleChange(e, 'dataDesvinculacao')}
              value={props.estadoFormulario.requerimento.dataDesvinculacao}
              touched={props.estadoFormulario.touched}
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <ProtectedItem allowedPermissions={controleCampoAlternativos('dataCreditoPagamento')}>
              <Input
                disabled={verificaSeCampoDesabilitado('dataCreditoPagamento')}
                error={'dataCreditoPagamento' in props.estadoFormulario.validadeCampos ? !props.estadoFormulario.validadeCampos.dataCreditoPagamento : false}
                mask={Masks.date}
                label="Data de Crédito do Pagamento"
                onChange={e => props.handleChange(e, 'dataCreditoPagamento')}
                value={props.estadoFormulario.requerimento.dataCreditoPagamento}
                touched={props.estadoFormulario.touched}
              />
            </ProtectedItem>
            <ProtectedItem allowedPermissions={controleCampoAlternativos('dataHomologacaoTribunalContas')}>
              <Input
                disabled={verificaSeCampoDesabilitado('dataHomologacaoTribunalContas')}
                error={'dataHomologacaoTribunalContas' in props.estadoFormulario.validadeCampos ? !props.estadoFormulario.validadeCampos.dataHomologacaoTribunalContas : false}
                mask={Masks.date}
                label="Data de Homologação no Tribunal de Contas"
                onChange={e => props.handleChange(e, 'dataHomologacaoTribunalContas')}
                value={props.estadoFormulario.requerimento.dataHomologacaoTribunalContas}
                touched={props.estadoFormulario.touched}
              />
            </ProtectedItem>
          </Grid>
        </div>
        <div className="row">
          {props.estadoFormulario.exibirCampoUoInss ?
            <Grid cols="4 4 4 4">
              <Input
                disabled
                label="UO INSS"
                value={props.estadoFormulario.requerimento.idUOMantenedora}
                touched={props.estadoFormulario.touched}
                required
              />
            </Grid>
          :
            <ProtectedItem allowedPermissions={controleCampoAlternativos('idUOMantenedora')}>
              <Grid cols="4 4 4 4">
                <Input
                  disabled
                  label="UO INSS"
                  value={props.estadoFormulario.requerimento.idUOMantenedora}
                  touched={props.estadoFormulario.touched}
                  required
                />
              </Grid>
            </ProtectedItem>
          }
          {(isDestinatarioRPPS() && isSolicitanteRPPS()) &&
            <Grid cols="4 4 4 4">
              <Input
                disabled={['realizar-analise', 'consulta'].includes(props.estadoFormulario.acao)}
                error={'regraDeCalculo' in props.estadoFormulario.validadeCampos ? !props.estadoFormulario.validadeCampos.regraDeCalculo : false}
                label="Regra de Cálculo"
                itemList={regrasDeCalculo}
                onChange={e => props.handleChange(e, 'regraDeCalculo')}
                value={props.estadoFormulario.requerimento.regraDeCalculo}
                touched={props.estadoFormulario.touched}
                required
              />
            </Grid>
          }
          <SegregacaoDeMassa
            estadoFormulario={props.estadoFormulario}
            handleChange={props.handleChange}
            handleModalAlteraSegregacaoMassa={props.handleModalAlteraSegregacaoMassa}
            tipoSegregacaoDestinatario={props.estadoFormulario.requerimento.tipoSegregacaoDestinatario}
            tipoSegregacaoSolicitante={props.estadoFormulario.requerimento.tipoSegregacaoSolicitante}
          />
        </div>
        <div className="row">
          <ProtocoloCertidao
            estadoFormulario={props.estadoFormulario}
            handleChange={props.handleChange}
            handleChangeProtocoloNaoConstaOuIlegivel={props.handleChangeProtocoloNaoConstaOuIlegivel}
            handleSearchPeriodos={props.handleSearchPeriodos}
            verificaAcaoExibicaoBotaoPesquisarCTC={verificaAcaoExibicaoBotaoPesquisarCTC}
          />
          <Grid cols={verificarTamanhoInput()}>
            <input
              value={props.estadoFormulario.requerimento.alteracaoTempoRO}
              key="alteracaoManualTempoRo"
              label="Alteração manual de tempo RO"
              type="checkbox"
              checked={checkedTempoRO}
              onClick={() => toggleCheckbox(clicouTempoRO, 'alteracaoManualTempoRo')}
              style={{ paddingLeft: '5px', position: 'relative', top: '20px' }}
              disabled={verificaSeCampoDesabilitado('alteracaoManualTempoRo')}
            />
            <span style={{ paddingLeft: '5px', position: 'relative', top: '19px' }}>Alteração manual de tempo RO</span>
          </Grid>
          {(isExibirCtcEspecifica()) ?
            <Grid cols="3 3 3 3">
              <input
                value={props.estadoFormulario.requerimento.ctcEspecifica}
                key="ctcEspecifica"
                label="CTC Específica"
                type="checkbox"
                checked={checkedCtcEspecifica}
                onClick={() => toggleCheckbox(clicouCtcEspecifica, 'ctcEspecifica')}
                style={{ paddingLeft: '5px', position: 'relative', top: '20px' }}
                disabled={verificaSeCampoDesabilitado('ctcEspecifica')}
              />
              <span style={{ paddingLeft: '5px', position: 'relative', top: '19px' }}>CTC Específica</span>
            </Grid>
          : ''}
        </div>
      </DataGrid>
      {(props.estadoFormulario.exibirMultiplosPeriodos) &&
        <MultiplosPeriodos
          estadoFormulario={props.estadoFormulario}
          handleChange={props.handleChange}
          atualizarDataIngressoDesvinculacaoETempo={props.atualizarDataIngressoDesvinculacaoETempo}
          ordenarListaPeriodos={props.ordenarListaPeriodos}
          determinarConcomitancias={props.determinarConcomitancias}
          calcularPeriodoRgps={props.calcularPeriodoRgps}
          calcularPeriodoRpps={props.calcularPeriodoRpps}
        />
      }
      {['novo', 'criado', 'indeferidos', 'cumprir-exigencia'].includes(props.estadoFormulario.acao) || props.exibirUploadArquivosNaConsulta ?
        <UploadArquivos
          acao={props.estadoFormulario.acao}
          arquivos={props.estadoFormulario.requerimento.arquivos ? [...props.estadoFormulario.requerimento.arquivos] : []}
          estadoFormulario={props.estadoFormulario.estadoFormulario}
          handleChange={e => props.handleChange(e, 'arquivos')}
          auth={props.auth}
          tipoRequerimento={props.estadoFormulario.tipoRequerimento}
          tiposDocumentos={props.tiposDocumentos}
          requerimento={props.estadoFormulario.requerimento}
          listaExigencias={props.estadoFormulario.exigenciasOriginais ?
            props.estadoFormulario.exigenciasOriginais : []}
          temBloqueioAtivoContratoDtp={props.temBloqueioAtivoContratoDtp}
        />
      : '' }
      {props.estadoFormulario.acao === 'novo' || props.estadoFormulario.acao === 'criado' ||
      props.estadoFormulario.acao === 'indeferidos' || props.exibirModalCadeiaDeNit ?
        <ModalCadeiaDeNit
          acao={props.estadoFormulario.acao}
          estadoFormulario={props.estadoFormulario.estadoFormulario}
          nit={props.estadoFormulario.requerimento.nit}
          elos={props.estadoFormulario.requerimento.elos}
          handleModal={() => props.handleModalCadeiaDeNitModal()}
          showModal={props.exibirModalCadeiaDeNit}
          dataMigracao={props.estadoFormulario.requerimento.dataMigracao}
        />
      : '' }
      {props.exibirModalDataCessacao ?
        <ModalAlteracaoDataCessacao
          acao={props.estadoFormulario.acao}
          protocolo={props.estadoFormulario.requerimento.protocolo}
          dataCessacaoBeneficio={props.estadoFormulario.requerimento.dataCessacaoBeneficio}
          handleModal={() => props.handleModalAlteraDataCessacao()}
          showModal={props.exibirModalDataCessacao}
          tipoRequerimento={props.estadoFormulario.tipoRequerimento}
          atualizarDataCessacao={props.atualizarDataCessacao}
          atualizarMotivoCessacao={props.atualizarMotivoCessacao}
          estadoFormulario={props.estadoFormulario}
        />
      : '' }
      {props.exibirModalMotivoCessacao ?
        <ModalAlteracaoMotivoCessacao
          acao={props.estadoFormulario.acao}
          protocolo={props.estadoFormulario.requerimento.protocolo}
          motivoCessacaoManual={props.estadoFormulario.requerimento.motivoCessacaoManual}
          handleModal={() => props.handleModalAlteraMotivoCessacao()}
          showModal={props.exibirModalMotivoCessacao}
          atualizarMotivoCessacao={props.atualizarMotivoCessacao}
          atualizarHistoricoAuditorias={props.atualizarHistoricoAuditorias}
          estadoFormulario={props.estadoFormulario}
          handleChange={props.handleChange}
        />
      : '' }
      {props.exibirModalDataEMotivoCessacao ?
        <ModalAlteracaoDataEMotivoCessacao
          acao={props.estadoFormulario.acao}
          protocolo={props.estadoFormulario.requerimento.protocolo}
          motivoCessacaoManual={props.estadoFormulario.requerimento.motivoCessacaoManual}
          dataCessacaoBeneficio={props.estadoFormulario.requerimento.dataCessacaoBeneficio}
          handleChange={props.handleChange}
          showModal={props.exibirModalDataEMotivoCessacao}
          estadoFormulario={props.estadoFormulario}
          atualizarMotivoCessacao={props.atualizarMotivoCessacao}
          atualizarDataCessacao={props.atualizarDataCessacao}
          atualizarHistoricoAuditorias={props.atualizarHistoricoAuditorias}
          handleModal={() => props.handleModalAlteraDataEMotivoCessacao()}
        />
      : '' }
      {props.exibirModalSegregacaoMassa ?
        <ModalAlteracaoSegregacaoMassa
          acao={props.estadoFormulario.acao}
          protocolo={props.estadoFormulario.requerimento.protocolo}
          tipoSegregacaoDestinatario={props.estadoFormulario.requerimento.tipoSegregacaoDestinatario}
          tipoSegregacaoSolicitante={props.estadoFormulario.requerimento.tipoSegregacaoSolicitante}
          handleModal={() => props.handleModalAlteraSegregacaoMassa()}
          showModal={props.exibirModalSegregacaoMassa}
          tipoRequerimento={props.estadoFormulario.tipoRequerimento}
          atualizarTipoSegregacaoMassaDestinatario={props.atualizarTipoSegregacaoMassaDestinatario}
          atualizarTipoSegregacaoMassaSolicitante={props.atualizarTipoSegregacaoMassaSolicitante}
          origem={props.estadoFormulario.origemModalSegregacaoMassa}
        />
      : '' }
      { calculoCompensacao }
      { documentosProbatorios }
      { resultadoAnalise }
      { cumprimentoExigencia }
    </React.Fragment>
  );
};

DadosRequerimentoAposentadoria.propTypes = {
  entesControlados: PropTypes.arrayOf(PropTypes.object).isRequired,
  enteDoUsuario: PropTypes.objectOf(PropTypes.string).isRequired,
  solicitanteRequerimento: PropTypes.string.isRequired,
  acao: PropTypes.string.isRequired,
  alteraEstadoRequerimento: PropTypes.func.isRequired,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
  camposCnis: PropTypes.arrayOf(PropTypes.string).isRequired,
  camposCentralService: PropTypes.arrayOf(PropTypes.string).isRequired,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleChangeExigirQualificacao: PropTypes.func.isRequired,
  handleChangeTempoROManual: PropTypes.func.isRequired,
  handleChangeCtcEspecifica: PropTypes.func.isRequired,
  handleChangeProtocoloNaoConstaOuIlegivel: PropTypes.func.isRequired,
  handleKeyUp: PropTypes.func.isRequired,
  handleSearchButton: PropTypes.func.isRequired,
  handlePesquisaBotaoEloNit: PropTypes.func.isRequired,
  handleModalCadeiaDeNitModal: PropTypes.func.isRequired,
  handleModalAlteraDataCessacao: PropTypes.func.isRequired,
  handleModalAlteraDataEMotivoCessacao: PropTypes.func.isRequired,
  handleModalAlteraMotivoCessacao: PropTypes.func.isRequired,
  handleModalAlteraSegregacaoMassa: PropTypes.func.isRequired,
  handleSearchNBButton: PropTypes.func.isRequired,
  apagaRegraDeCalculo: PropTypes.func.isRequired,
  vinculosConcomitantesConfirmado: PropTypes.bool.isRequired,
  possuiVinculosConcomitantes: PropTypes.bool.isRequired,
  clickVinculosTab: PropTypes.func.isRequired,
  exibirUploadArquivosNaConsulta: PropTypes.bool.isRequired,
  exibirModalCadeiaDeNit: PropTypes.bool.isRequired,
  exibirModalDataCessacao: PropTypes.bool.isRequired,
  exibirModalMotivoCessacao: PropTypes.bool.isRequired,
  exibirModalDataEMotivoCessacao: PropTypes.bool.isRequired,
  exibirModalSegregacaoMassa: PropTypes.bool.isRequired,
  atualizarDataCessacao: PropTypes.func.isRequired,
  atualizarMotivoCessacao: PropTypes.func.isRequired,
  atualizarHistoricoAuditorias: PropTypes.func.isRequired,
  atualizarTipoSegregacaoMassaDestinatario: PropTypes.func.isRequired,
  atualizarTipoSegregacaoMassaSolicitante: PropTypes.func.isRequired,
  handleSearchPeriodos: PropTypes.func.isRequired,
  atualizarDataIngressoDesvinculacaoETempo: PropTypes.func.isRequired,
  determinarConcomitancias: PropTypes.func.isRequired,
  ordenarListaPeriodos: PropTypes.func.isRequired,
  calcularPeriodoRgps: PropTypes.func.isRequired,
  calcularPeriodoRpps: PropTypes.func.isRequired,
  calcularTempoRO: PropTypes.func.isRequired,
  atualizarTempoRO: PropTypes.func.isRequired,
  handleModalTempoRO: PropTypes.func.isRequired,
  validacaoDeVinculosConcomitantes: PropTypes.func.isRequired,
  atualizarVinculosConcomitantesConfirmado: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      acao: PropTypes.string,
    }),
  }),
  tiposDocumentos: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  atualizarDocumentosProbatorios: PropTypes.func.isRequired,
  temBloqueioAtivoContratoDtp: PropTypes.bool.isRequired,
  handleChangeFile: PropTypes.func.isRequired,
  handleChangeTipoDocumento: PropTypes.func.isRequired,
  motivosCessacao: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
};

DadosRequerimentoAposentadoria.defaultProps = {
  match: null,
  tiposDocumentos: [],
  motivosCessacao: null,

};
const mapStateToProps = state => ({
  entesControlados: state.base.entesControlados,
  enteDoUsuario: state.base.enteDoUsuario,
  solicitanteRequerimento: state.base.solicitanteRequerimento,
  motivosCessacao: state.base.motivosCessacao,
});

export default connect(mapStateToProps)(DadosRequerimentoAposentadoria);



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Aposentadoria/DadosRequerimentoAposentadoria.jsx